import {
  FETCHING_VOUCHER_DATA,
  SET_VOUCHER_CODE,
  SET_VOUCHER_DETAIL,
  VoucherActionTypes,
  VoucherState,
} from '../types';

const initialState: VoucherState = {
  fetchingVoucherData: false,
};

function VoucherReducer(state = initialState, action: VoucherActionTypes): VoucherState {
  switch (action.type) {
    case SET_VOUCHER_CODE:
      return { ...state, voucherData: action.payload };
    case FETCHING_VOUCHER_DATA:
      return { ...state, fetchingVoucherData: action.payload };
    case SET_VOUCHER_DETAIL:
      return {
        ...state,
        voucherDetail: action.payload,
      };
    default:
      return state;
  }
}

export default VoucherReducer;
